import { createUseStyles } from 'react-jss';
import { color, fontSize, spacing } from '@blink/components';

export const usePersonalisedPoolStyle = createUseStyles({
    heading: {
        display: 'flex',
        padding: `${spacing['06']} 0px`,
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        alignSelf: 'stretch',
    },
    title: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: spacing['02'],
    },
    titleText: {
        color: color.content.primary,
        fontSize: '32px',
        fontWeight: 600,
        lineHeight: '40px',
        letterSpacing: '-0.64px',
    },
    top: {
        display: 'flex',
        padding: `${spacing['08']} 10% ${spacing['07']}`,
        flexDirection: 'column',
        alignItems: 'flex-start',
        alignSelf: 'stretch',
    },
    content: {
        display: 'flex',
        padding: `0 10% ${spacing['10']}`,
        flexDirection: 'column',
        alignItems: 'flex-start',
        alignSelf: 'stretch',
        gap: 24,
    },
    description: {
        color: color.content.secondary,
    },
    param: {
        display: 'flex',
        flexDirection: 'column',
        gap: spacing['02'],
        width: 680,
    },
    btn: {
        display: 'flex',
        marginTop: spacing['04'],
        alignItems: 'center',
        gap: spacing['07'],
        '& button.ant-btn': {
            height: 44,
            width: 138,
        },
    },
    breadcrumbs: {
        display: 'flex',
        alignItems: 'center',
        margin: `${spacing['05']} 0`,
        color: color.content.secondary,
        fontSize: fontSize.lg,
        gap: spacing['03'],
    },
    input: {
        padding: `0 ${spacing['09']} 0 ${spacing['04']}`,
        border: `1px solid ${color.border.opaque}`,
        borderRadius: 4,
        height: 44,
        width: '100%',
        backgroundColor: color.background.primary,
        '&.ant-input-outlined:focus-within': {
            borderColor: color.border.opaque,
            boxShadow: 'none !important',
            backgroundColor: color.background.primary,
        },
        '&.ant-input-number-outlined:focus-within': {
            borderColor: color.border.opaque,
            boxShadow: 'none !important',
            backgroundColor: color.background.primary,
        },
        '& .ant-input-number-input': {
            height: 44,
            padding: 0,
            '&:placeholder': {
                color: `${color.content.secondary} !important`,
            },
        },
        '& .ant-select-selector': {
            padding: `0 ${spacing['04']}`,
            border: `none !important`,
            background: `none !important`,
            boxShadow: `none !important`,
        },
        '&.ant-select.ant-select-outlined': {
            padding: 0,
        },
        '&.error': {
            borderColor: color.border.negative,
        },
    },
    textArea: {
        width: '100% !important',
        '& .ant-input-textarea-show-count .ant-input-data-count': {
            bottom: 2,
            right: 12,
        },
        '& textarea': {
            height: `120px`,
        },
    },
    textWrapper: {
        '&.ant-input-affix-wrapper.ant-input-textarea-affix-wrapper': {
            paddingBottom: 20,
        },
    },
    group: {
        width: 280,
        fontWeight: 500,
        '& .ant-radio-button-wrapper': {
            height: 42,
            padding: `1px 20px`,
        },
        '& .ant-radio-button-wrapper-checked': {
            border: `2px solid ${color.border.accent} !important`,
            padding: `0 19px !important`,
        },
    },
    icon: {
        width: 18,
        height: 18,
        padding: 2,
    },
    tooltip: {
        '& .ant-tooltip-inner': {
            padding: `${spacing['03']} ${spacing['04']}`,
            fontSize: 12,
        },
    },
    label: {
        display: 'flex',
    },
    tokenBtn: {
        display: 'flex',
        width: 'fit-content',
        minWidth: 40,
        height: 40,
        padding: '6px 10px',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 320,
        border: `1px solid ${color.border.opaque}`,
        background: color.background.secondary,
        gap: spacing['03'],
        '& img': {
            width: 20,
            height: 20,
        },
        '&.active': {
            border: `1px solid ${color.border.accent}`,
            background: color.background.lightAccent,
            color: color.content.accent,
            '&:hover': {
                border: `1px solid ${color.border.accent} !important`,
                background: `${color.background.lightAccent} !important`,
                color: `${color.content.accent}`,
            },
            '& .icon': {
                '& rect': {
                    fill: color.content.accent,
                },
            },
        },
        '& div.ant-wave': {
            display: 'none',
        },
    },
    btnWrapper: {
        display: 'flex',
        gap: 4,
    },
    error: {
        color: color.content.negative,
    },
    text: {
        width: 680,
        color: color.content.secondary,
    },
});
